define("settings/controllers/overview/downgrade", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking"], function (_exports, _controller, _object, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let DowngradeController = (_class = class DowngradeController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _initializerDefineProperty(this, "initialHasOverageLinkinbioPages", _descriptor5, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get initialHasOverageGroups() {
      return this.overageGroups > 0;
    }

    get initialHasOverageSocialSets() {
      return this.overageSocialSets > 0;
    }

    get initialHasOverageUsers() {
      return this.overageUsers > 0;
    }

    get overageGroups() {
      return this.upcomingOverages?.clusters;
    }

    get overageLinkinbioPages() {
      return this.currentAccount.linkinbioPagesOverage;
    }

    get overageSocialSets() {
      return this.currentAccount?.setsOverages;
    }

    get overageUsers() {
      return this.upcomingOverages?.users;
    }

    get upcomingOverages() {
      return this.currentAccount.upcomingOverages;
    }

    organizeSocialProfiles() {
      this.dialogManager.confirm(this.intl.t('account.downgrade.social_sets.organize.confirm_dialog'), {
        description: this.intl.t('account.downgrade.social_sets.organize.description'),
        confirmButton: this.intl.t('account.downgrade.social_sets.organize.confirm_btn')
      }).then(() => {
        this.router.transitionTo('account.groups.trade');
      });
    }

    updateInitialHasOverageLinkinbioPages(linkinbioPages) {
      this.initialHasOverageLinkinbioPages = linkinbioPages.length > this.currentAccount.socialSetCount;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "initialHasOverageLinkinbioPages", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.overageLinkinbioPages > 0;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "organizeSocialProfiles", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "organizeSocialProfiles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialHasOverageLinkinbioPages", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialHasOverageLinkinbioPages"), _class.prototype)), _class);
  _exports.default = DowngradeController;
});